import { useMutation, MutationFunction, MutationOptions } from 'react-query';
import {
    createWorkTravelZone,
    updateWorkTravelZone,
    deleteWorkTravelZone,
    CreateWorkTravelZoneBody,
    UpdateWorkTravelZoneBody,
    WorkTravelZoneResponse,
} from '../../services/apiSLTP/sites/workTravelZones';

type UseCreateWorkTravelZoneMutationOptions = MutationOptions<WorkTravelZoneResponse, Error, CreateWorkTravelZoneBody>;

type UseUpdateWorkTravelZoneMutationOptions = MutationOptions<WorkTravelZoneResponse, Error, { id: string; data: UpdateWorkTravelZoneBody }>;

type UseDeleteWorkTravelZoneMutationOptions = MutationOptions<WorkTravelZoneResponse, Error, string>;

export const useCreateWorkTravelZoneMutation = (options?: UseCreateWorkTravelZoneMutationOptions) => {
    const mutationFn: MutationFunction<WorkTravelZoneResponse, CreateWorkTravelZoneBody> = async (data) => {
        return await createWorkTravelZone(data);
    };

    return useMutation(mutationFn, options);
};

export const useUpdateWorkTravelZoneMutation = (options?: UseUpdateWorkTravelZoneMutationOptions) => {
    const mutationFn: MutationFunction<WorkTravelZoneResponse, { id: string; data: UpdateWorkTravelZoneBody }> = async ({ id, data }) => {
        return await updateWorkTravelZone(id, data);
    };

    return useMutation(mutationFn, options);
};

export const useDeleteWorkTravelZoneMutation = (options?: UseDeleteWorkTravelZoneMutationOptions) => {
    const mutationFn: MutationFunction<WorkTravelZoneResponse, string> = async (id) => {
        return await deleteWorkTravelZone(id);
    };

    return useMutation(mutationFn, options);
};
